$(function(){

    App.Seo =  {
        
        init: function(){
            
            this.phoneClick();
            this.emailClick();
            
        },

        send: function(eventType, eventName){

            try {

                switch (eventType) {

                    case 'formSend':

                        switch (eventName) {

                            case 'feedback':

                                dataLayer.push({
                                    'event':'Feedback',
                                    'eventCategory':'Feedback',
                                    'eventAction':'send'
                                });

                                break;

                        }

                        break;

                    case 'tenderClick':

                        dataLayer.push({
                            'event':'Tender',
                            'eventCategory':'Tender',
                            'eventAction':'click',
                            'eventLabel':eventName
                        });

                        break;

                    case 'socIconClick':

                        dataLayer.push({
                            'event':'Social',
                            'eventCategory':'Social',
                            'eventAction':'click',
                            'eventLabel':eventName
                        });

                        break;

                }

            } catch (e) {
                console.log(e);
            }

        },
        
        phoneClick: function(){
            
            $(document).on('click', 'a[href^=tel]', function(){
                dataLayer.push({
                    'event':'Phone',
                    'eventCategory':'Phone',
                    'eventAction':'click',
                    'eventLabel': $(this).attr('href').replace('tel:', '')
                })
            });
            
        },

        emailClick: function(){

            $(document).on('click', 'a[href^=mailto]', function(){
                dataLayer.push({
                    'event':'Email',
                    'eventCategory':'Email',
                    'eventAction':'click',
                    'eventLabel': $(this).attr('href').replace('mailto:', '')
                });
            });

        }

    };
    
    App.Seo.init();
    
});